import { render, staticRenderFns } from "./shopCreateTask.vue?vue&type=template&id=5cadfd71&scoped=true"
import script from "./shopCreateTask.vue?vue&type=script&lang=js"
export * from "./shopCreateTask.vue?vue&type=script&lang=js"
import style0 from "./shopCreateTask.vue?vue&type=style&index=0&id=5cadfd71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cadfd71",
  null
  
)

export default component.exports